import React from 'react';

import '../../../src/styles/global.css';

function LoadingState() {
  return (<div className="lr-loading-state" />);
}

export default LoadingState;